export default {"src":"/_next/static/media/heart-border.4cce620f.svg","height":48,"width":48};